/**
 * Job energy type enum
 * @type {{ELECTRICITY: string, WATER: string, HEATING: string, GAS: string}}
 */
export const JOB_ENERGYTYPE = {
    ELECTRICITY: 'electricity',
    WATER: 'water',
    HEATING: 'heating',
    GAS: 'gas'
};
